import "./index.css"

import React from 'react'
import { Route, Routes } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";
import Home from './pages/Home'
import Success from './pages/Success';
function App() {
  return (
    <>
    <HelmetProvider>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/success" element={<Success/>} />
      </Routes>
      </HelmetProvider>
    </>
  )
}

export default App

